import React, { useEffect, useRef } from 'react';

const AuroraBackground = ({ className = '' }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        const drawAurora = () => {
            time += 0.005;
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const gradient1 = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
            gradient1.addColorStop(0, 'rgba(0, 212, 255, 0.1)');
            gradient1.addColorStop(0.5, 'rgba(124, 58, 237, 0.1)');
            gradient1.addColorStop(1, 'rgba(245, 158, 11, 0.1)');

            const gradient2 = ctx.createLinearGradient(canvas.width, 0, 0, canvas.height);
            gradient2.addColorStop(0, 'rgba(245, 158, 11, 0.1)');
            gradient2.addColorStop(0.5, 'rgba(34, 197, 94, 0.1)');
            gradient2.addColorStop(1, 'rgba(0, 212, 255, 0.1)');

            ctx.fillStyle = gradient1;
            ctx.beginPath();
            ctx.ellipse(
                canvas.width * 0.3 + Math.sin(time) * 100,
                canvas.height * 0.3 + Math.cos(time * 0.7) * 80,
                canvas.width * 0.4,
                canvas.height * 0.3,
                Math.sin(time * 0.5) * 0.3,
                0,
                Math.PI * 2
            );
            ctx.fill();

            ctx.fillStyle = gradient2;
            ctx.beginPath();
            ctx.ellipse(
                canvas.width * 0.7 + Math.cos(time * 0.8) * 120,
                canvas.height * 0.7 + Math.sin(time * 0.6) * 100,
                canvas.width * 0.35,
                canvas.height * 0.35,
                Math.cos(time * 0.4) * 0.2,
                0,
                Math.PI * 2
            );
            ctx.fill();

            animationFrameId = requestAnimationFrame(drawAurora);
        };

        drawAurora();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            className={className}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0,
                pointerEvents: 'none',
                opacity: 0.6
            }}
        />
    );
};

export default AuroraBackground;

